<section
  class="hero-section relative flex flex-col items-center justify-center h-52 md:h-[400px] lg:h-[600px] text-ayr-black dark:text-ayr-white"
>
  <div class="z-50 absolute">
    <h1 class="text-27 md:text-37 lg:text-47 leading-none ">
      Are you ready to build <br />
      <b>a <span class="ayr-underline dark:dark:text-shadow">carbon-zero world</span>?</b>
    </h1>
    <div
      class="grid justify-center justify-items-center mt-9 cursor-pointer"
      (click)="playModalPlay()"
    >
      <img
        class="lg:max-w-16 max-w-12"
        width="48"
        height="48"
        src="https://storage.googleapis.com/weayr-assets-non-prod/images/home/play.png"
        alt="Icon play"
      />
      <p class="text-13 lg:text-18 text-bold mt-1.5">
        {{ "play-video" | translate }}
      </p>
    </div>
  </div>

  <div class="absolute inset-0 -z-10">
    <ng-content />
  </div>
</section>
